import { useAuth } from "@/App";
import { usePageHeader } from "@/components/layouts/lib/page-header";
import { CreanceAccrualAction } from "./creances/components/CreanceAccrualAction";
import { CreanceDetailDialog } from "./creances/components/CreanceDetailDialog";
import { CreanceStatsGrid } from "./creances/components/CreanceStatsGrid";
import { CreancesContent } from "./creances/components/CreancesContent";
import { CreancesPageIntro } from "./creances/components/CreancesPageIntro";
import { CreancesToolbar } from "./creances/components/CreancesToolbar";
import { CREANCES_PAGE_GUIDE } from "./creances/creance.constants";
import { useCreanceAccrualAction } from "./creances/hooks/useCreanceAccrualAction";
import { useCreancesPageData } from "./creances/hooks/useCreancesPageData";
import { useCreancesPageState } from "./creances/hooks/useCreancesPageState";

export default function CreancesPage() {
  const { user } = useAuth();
  const pageState = useCreancesPageState();
  const pageData = useCreancesPageData({
    onlyOverdue: pageState.onlyOverdue,
    search: pageState.search,
  });
  const accrual = useCreanceAccrualAction();
  const canAccrueNow = user?.role === "super_admin";

  usePageHeader({
    title: "Créances",
    helpTopic: "creances",
    guide: {
      steps: CREANCES_PAGE_GUIDE,
    },
  });

  return (
    <div>
      <CreancesPageIntro filteredCount={pageData.filteredRows.length} />
      <CreanceAccrualAction
        visible={canAccrueNow}
        isAccruing={accrual.isAccruing}
        result={accrual.accrueResult}
        onAccrueNow={accrual.accrueNow}
      />
      <CreanceStatsGrid rowsCount={pageData.rows.length} metrics={pageData.metrics} />
      <CreancesToolbar
        search={pageState.search}
        onlyOverdue={pageState.onlyOverdue}
        viewMode={pageState.viewMode}
        rowsCount={pageData.rows.length}
        onSearchChange={pageState.setSearch}
        onOnlyOverdueChange={pageState.setOnlyOverdue}
        onViewModeChange={pageState.setViewMode}
      />
      <CreancesContent
        rows={pageData.filteredRows}
        viewMode={pageState.viewMode}
        isLoading={pageData.isLoading}
        onSelect={pageState.setSelectedCreance}
      />
      <CreanceDetailDialog
        creance={pageState.selectedCreance}
        onOpenChange={(open) => {
          if (!open) pageState.setSelectedCreance(null);
        }}
      />
    </div>
  );
}
